module.exports = __webpack_public_path__ + "static/media/before_after_cut.e13d2138.png";